import {
  AGENCY_FEATURES_EDIT_REQUEST_RESPONSE,
  AGENCY_FEATURES_ERROR,
  AGENCY_FEATURES_REQUEST,
  AGENCY_FEATURES_REQUEST_RESPONSE,
  AGENCY_FEATURES_UNLOAD,
} from "./types";

export const agencyFeatures = (
  state = {
    agencyFeatures: {},
    isFetchingAgencyFeatures: false,
    agencyFeaturesError: false,
  },
  action
) => {
  switch (action.type) {
    case AGENCY_FEATURES_REQUEST:
      return {
        ...state,
        isFetchingAgencyFeatures: true,
        agencyFeaturesError: false,
      };
    case AGENCY_FEATURES_REQUEST_RESPONSE:
      return {
        ...state,
        agencyFeatures: action.data?.data,
        isFetchingAgencyFeatures: false,
        agencyFeaturesError: false,
      };
    case AGENCY_FEATURES_EDIT_REQUEST_RESPONSE:
      return {
        ...state,
        agencyFeatures: action.data?.data,
        isFetchingAgencyFeatures: false,
        agencyFeaturesError: false,
      };
    case AGENCY_FEATURES_ERROR:
      return {
        ...state,
        agencyFeaturesError: action.error,
        isFetchingAgencyFeatures: false,
      };
    case AGENCY_FEATURES_UNLOAD:
      return {
        ...state,
        isFetchingAgencyFeatures: false,
        agencyFeaturesError: false,
        agencyFeatures: {},
      };
    default:
      return state;
  }
};
